import { useEffect, useState } from "react";
import { useNotification } from "~hooks/useNotification";

export const useErrorNotification = (error, cleanError, errorMsg) => {
  const notification = useNotification();

  useEffect(() => {
    if (error) {
      notification.error({
        message: errorMsg,
        placement: "bottomRight",
      });
      cleanError();
    }
  }, [error, cleanError, errorMsg]);
};
